export default Backbone.View.extend({
  // A container view responsible for signaling the state of the page
  initialize() {
    Rover.pubSub.on('search:start', _.bind(this.onSearchStart, this));
    Rover.pubSub.on('search:end', _.bind(this.onSearchEnd, this));
  },

  onSearchStart() {
    this.$el.addClass('search-in-progress');
  },

  onSearchEnd() {
    this.$el.removeClass('search-in-progress');
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_page_view.js